import { render } from "./PackageSelect.vue?vue&type=template&id=be31c086&scoped=true"
import script from "./PackageSelect.vue?vue&type=script&lang=js"
export * from "./PackageSelect.vue?vue&type=script&lang=js"

import "./PackageSelect.vue?vue&type=style&index=0&id=be31c086&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be31c086"]])

export default __exports__